import Pochta from "./Pochta";
function ENTJ()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
           <div className="image-wrapper">
      <img src="/img/ЕNTJ Командир.png" className="ENTJ"/>
      </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
         <h2>ENTJ</h2>
      <p><strong>Процент населения:</strong> 2–5%</p>
<p><strong>Среди мужчин:</strong> 3–5%</p>
<p><strong>Среди женщин:</strong> 1–3%</p>
<p><strong>Стратегия:</strong> Лидерство и влияние</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  ENTJ черпают энергию из общения и достижения целей. 
  Им нужно движение, результаты и признание. 
  Они восстанавливают силы, ведя за собой других и решая сложные задачи.
</p>
<p>
  Решения ENTJ принимают на основе логики и стратегического мышления. 
  Они доверяют своему аналитическому уму и редко сомневаются. 
  Они ценят эффективность, результат и компетентность.
</p>
<p>
  Это прирождённые лидеры и организаторы. 
  Они всегда видят цель и знают, как к ней прийти. 
  Им трудно мириться с неэффективностью, но их энергия заражает.
</p>

<p><strong>Особенность:</strong></p>
<p>
  ENTJ — это танк, который не остановится ни перед чем. Они задавливают авторитетом, 
  давят на слабых, не терпят возражений. Им плевать на чувства — важен результат. 
  Они могут казаться тиранами, потому что всегда знают, как лучше. 
  С ними сложно спорить, потому что они всегда аргументируют свою позицию.
</p>

<p>
  ENTJ — это человек, который берёт невозможную задачу, разбивает её на части, 
  распределяет роли и к утру сдаёт результат. Они не ищут лёгких путей — 
  они ищут правильные. Их харизма — не магия, а уверенность в своей правоте. 
  Если ENTJ сказал «это возможно» — значит, это уже сделано.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default ENTJ;